module.exports = "../img/bg-signup.jpg";